import React, { useContext } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import RouteAccordion from './RouteAccordion'
import { FloatingPanel } from '../CentrePanel'
import { PTSControlContext } from '../PTSControl'

const RouteInspector = ({ routes = [] }) => {
  const { selectedRoute, setSelectedRoute } = useContext(PTSControlContext)
  const scrollRef = React.useRef(null)

  return (
    <FloatingPanel
      sx={{
        width: { xs: '100%', sm: 390 },
        maxWidth: { xs: '100%', sm: 'calc(100vw - 48px)' },
        maxHeight: { xs: '100%', sm: 'calc(100% - 110px)' },
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 1.25,
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          flexShrink: 0,
        }}
      >
        <Typography
          sx={{
            color: '#F8FAFC',
            fontWeight: 800,
            fontSize: '0.98rem',
          }}
        >
          Routes
        </Typography>
        <Typography
          sx={{
            color: 'rgba(226,232,240,0.6)',
            fontSize: '0.76rem',
          }}
        >
          View journeys by route
        </Typography>
      </Box>

      <Box
        ref={scrollRef}
        sx={{
          p: 1,
          minHeight: 0,
          flex: 1,
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(148,163,184,0.45) transparent',
          '&::-webkit-scrollbar': { width: 8 },
          '&::-webkit-scrollbar-track': { background: 'transparent' },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(148,163,184,0.35)',
            borderRadius: 999,
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(148,163,184,0.55)',
          },
        }}
      >
        <Stack spacing={1}>
          {routes.map((route, routeIndex) => (
            <RouteAccordion
              key={route?._id || routeIndex}
              route={route}
              routeIndex={routeIndex}
              isSelected={selectedRoute?._id === route?._id}
              onSelect={(expanded) => setSelectedRoute(expanded ? route : null)}
            />
          ))}
        </Stack>
      </Box>
    </FloatingPanel>
  )
}

export default RouteInspector
